import { useMemo } from 'react';
import { useSettings } from '../features/admin/api.ts';
import { useAuth } from '../lib/auth.tsx';
import { satisfies } from '../lib/permissions.ts';
import { NAV_SECTIONS, type NavSection } from './nav.ts';

/** Which optional modules the workspace switched on (ตั้งค่าทั่วไป). Off while settings load. */
export function useEnabledModules(): { competition: boolean } {
  const settings = useSettings();
  return { competition: settings.data?.settings.modules?.competition === true };
}

/**
 * Sidebar sections the user can open: items filtered by permission, empty sections dropped,
 * optional modules hidden unless enabled. Pages stay reachable by URL and search either way.
 */
export function useNavSections(): NavSection[] {
  const { permissions } = useAuth();
  const modules = useEnabledModules();
  return useMemo(
    () =>
      NAV_SECTIONS.filter((s) => !s.feature || modules[s.feature])
        .map((s) => ({ ...s, items: s.items.filter((i) => !i.hidden && satisfies(permissions, i.anyOf)) }))
        .filter((s) => s.items.length > 0),
    [permissions, modules.competition],
  );
}

/** True when `pathname` is one of the section's pages (or below it). */
export function sectionMatches(section: NavSection, pathname: string): boolean {
  return section.items.some((i) => (i.to === '/' ? pathname === '/' : pathname === i.to || pathname.startsWith(`${i.to}/`)));
}
